import { render, staticRenderFns } from "./relatorioRetrato.vue?vue&type=template&id=39f36ca2"
import script from "./relatorioRetrato.vue?vue&type=script&lang=js"
export * from "./relatorioRetrato.vue?vue&type=script&lang=js"
import style0 from "./relatorioRetrato.vue?vue&type=style&index=0&id=39f36ca2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports